import React from 'react';
import { Link } from 'react-router-dom';
import Map from '../Map/Map';
import ContactData from '../Navbar/ContactData';
import CopyRight from './CopyRight';
import './Footer.css';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles({
  topdiv: {
    padding: '16px 4px',
    textAlign: 'center',
    ['@media(max-width:768px)']: {
      padding: ' 16px',
    },
  },
  secdiv: {
    marginBottom: '0px',
    display: 'flex',
    color: 'white',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'column',
    ['@media(min-width:1200px)']: {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
  p1: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    flexDirection: 'column',
    ['@media(min-width:767px)']: {
      flexDirection: 'row',
      marginBottom: '0px',
    },
  },
  icon: {
    marginBottom: '16px',
    display: 'none',
    ['@media(min-width:767px)']: {
      display: 'flex',
      marginBottom: '0px',
    },
  },
  divbelowmap: {
    padding: '16px 4px',
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '0',
    marginLeft: '0',
    justifyContent: 'center',
  },
  gridText: {
    textAlign: 'center',
    ['@media(max-width:767px)']: {
      textAlign: 'left',
    },
  },
});
function Footer() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <footer>
        <div className={`footerTop ${classes.topdiv}`}>
          <div className={classes.secdiv}>
            <p className={`address ${classes.p1}`}>
              <i className={`fa fa-map-marker ${classes.icon}`}></i>
              #48/11, 11th Main, 13th Cross, Malleswaram, Bengaluru, Karnataka,
              India 560003
            </p>
            <div
              className="contact "
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <div
                className="icons"
                style={{ display: 'flex', marginLeft: '4px' }}
              >
                <a href={`tel:${ContactData.phone}`}>
                  {' '}
                  <i className=" fa fa-phone" style={{ margin: '0 8px' }}></i>
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://wa.me/${ContactData.whatsapp}`}
                >
                  {' '}
                  <i
                    className=" fa fa-whatsapp"
                    style={{ margin: '0 8px' }}
                  ></i>
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://telegram.me/${ContactData.telegram}`}
                >
                  {' '}
                  <i
                    className=" fa fa-telegram"
                    style={{ margin: '0 8px' }}
                  ></i>
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    window.matchMedia('(max-width: 786px)').matches
                      ? `mailto:${ContactData.mail}`
                      : `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${ContactData.mail}`
                  }
                >
                  {' '}
                  <i
                    className=" fa fa-envelope"
                    style={{ margin: '0 8px' }}
                  ></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Added Code */}
        <div>
          <Map></Map>
        </div>
        <div className={`footerMiddle ${classes.divbelowmap}`}>
          <Grid sm={12} md={3} className={classes.gridText}>
            {/* <a href="{PDF}" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>{" "} */}
            <Link to="/privacyPolicy">
              {t('sections-Footer-Footer-Privacy')}
            </Link>{' '}
          </Grid>
          <Grid sm={12} md={3} className={classes.gridText}>
            {/* <a href="{PDF}" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>{" "} */}
            <Link to="/termCondition">{t('sections-Footer-Footer-TC')}</Link>{' '}
          </Grid>
          {/* <div className="col-sm-12  col-md-3  text-sm-left text-md-center mb-0">
            <p className="cursor-pointer mb-0 d-inline">Careers</p>
          </div> */}
          <Grid
            sm={12}
            md={3}
            className={classes.gridText}
            style={{ marginBottom: '0px' }}
          >
            <p style={{ marginBottom: '0px', display: 'inline' }}>
              GST NO: <span>1234 5678 9101 1121</span>{' '}
            </p>
          </Grid>
        </div>
        <CopyRight></CopyRight>
      </footer>
    </>
  );
}

export default Footer;
